module.exports = __webpack_public_path__ + "9dc396fc0bcb57f7ef062ffd76fc0c69.png";


//////////////////
// WEBPACK FOOTER
// ./assets/btnControlMute.png
// module id = dvJf
// module chunks = 27